import { MessageBox } from "element-ui";

export default class Notice {

  /**
   * @param {String} title
   * @param {String} text 提示文字
   * @param {Function} success 成功的回调(点击确认)
   * @param {Function} fail 失败的回调(点击取消)
   * @description 确认操作
   */
  static confirm({
    title = "提示", // 默认为"提示"
    text,
    success,
    fail = () => {
      // 默认为空方法
    },
    confirmButtonText = '确定',
    cancelButtonText = "取消"
  }) {
    MessageBox.confirm(text, title, {
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      type: "warning"
    })
      .then(() => {
        success();
      })
      .catch(() => {
        fail();
      });
  }
}
